module.exports = __webpack_public_path__ + "media/images/ticket/digital_ticket_title-9f7cc61d4fa28fe591fd23a5602ab73b.png";